class NotificationBanner {
  constructor(element) {
    this.element = element;
    this.close = this.element.querySelector('[data-element="notification-banner-close"]');
    this.cookieName = 'STYXKEY_cg_notification_banner';
  }

  init() {
    window.addEventListener('load', this.onWindowLoad.bind(this));
    this.close.addEventListener('click', this.onCloseClick.bind(this));
  }

  onWindowLoad() {
    if (false === this.checkIfCookieExists()) {
      this.showElement();
    }
  }

  onCloseClick() {
    this.setCookie();
    this.hideElement();
  }

  getCookie() {
    const matches = document.cookie.match(
      new RegExp(
        "(?:^|; )" + this.cookieName.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)" // eslint-disable-line
      )
    );

    return matches ? decodeURIComponent(matches[1]) : null;
  }

  checkIfCookieExists() {
    if (null !== this.getCookie()) {
      return true;
    }

    return false;
  }

  setCookie() {
    const expires = new Date();
    expires.setTime(expires.getTime() + 7 * 24 * 60 * 60 * 1000);
    document.cookie = this.cookieName + '=true' + '; Expires=' + expires.toUTCString() + '; Path=/; SameSite=Strict; Secure;';
  }

  showElement() {
    document.querySelector('body').classList.add('cg-has-notification-banner');
  }

  hideElement() {
    document.querySelector('body').classList.remove('cg-has-notification-banner');
  }
}

const notificationBanner = {
  init() {
    const notificationBannerElement = document.querySelector('[data-module="notification-banner"]');

    if (notificationBannerElement) {
      const notificationBannerItem = new NotificationBanner(notificationBannerElement);
      notificationBannerItem.init();
    }
  },
};

export default notificationBanner;
